import { atom } from "jotai";

import { CompProgress } from "@/hooks/chat/useUploadVideo";

export const videoProgressAtom = atom<CompProgress[] | null>(null);
videoProgressAtom.debugLabel = "videoProgressAtom";
